export function isSupportedOvertimeTimesheetDuration(duration) {
    return duration === 1 || duration === 7;
}
//# sourceMappingURL=overtime.js.map